import React from "react";
import { useEffect, useState } from "react";
import { getDescriptions } from "../../../services/kojaServices";
import toast from "react-hot-toast";
import {
  AddDescription,
  deleteDescription,
  editDescription,
} from "../../../services/adminServices";
import Swal from "sweetalert2";

const Description = () => {
  const [list, setList] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getDescriptions();
        setList(data.result);
        console.log(data);
      } catch (err) {
        console.log(err);
      }
    };
    fetchData();
  }, []);

  const addNew = async () => {
    try {
      const title = document.getElementById("title").value;
      if (title) {
        const { data } = await AddDescription({ name: title });
        toast.success("مورد جدید اضافه شد");
        console.log(data);
      } else {
        toast.error("لطفا یک مقدار وارد کنید");
      }
    } catch (err) {
      console.log(err);
      toast.error("خطایی رخ داده است مجددا تلاش کنید");
    }
  };
  const confirmDelete = (id) => {
    Swal.fire({
      title: "حذف آیتم",
      text: "ایا مطمئن هستید میخواهید این آیتم را حذف کنید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله",
      cancelButtonText:"انصراف"
    }).then((result) => {
      if (result.isConfirmed) {
        removeItem(id);
      }
    });
  };

  const removeItem = async (id) => {
    const allItem = [...list];
    try {
      const newArry = list.filter((item) => item.id != id)
      setList(newArry);
      const { data, status } = await deleteDescription(id);
      console.log(data, status);
      if (status != 201) {
        setList(allItem);
      } else {
        Swal.fire("حذف شد", "آیتم با موفقیت حذف شد", "success");
      }
    } catch (err) {
      console.log(err);
      // setProducts(allProduct);
      const x = err.response.status;
      toast.error("خطایی رخ داده است مجدد تلاش کنید");
    }
  };
  const confirmEdit = (id) => {
    Swal.fire({
      title: "ویرایش آیتم",
      text: "ایا مطمئن هستید میخواهید این آیتم را ویرایش کنید؟",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "بله",
      cancelButtonText:"انصراف"
    }).then((result) => {
      if (result.isConfirmed) {
        editItem(id);
      }
    });
  };
  const editItem = async (id) => {
    const title = document.getElementById(`newName${id}`).value;

    try {
      const { data, status } = await editDescription({ name: title, id: id });
      console.log(data, status);
      if (status != 201) {
      } else {
        Swal.fire("ویرایش شد", "آیتم با موفقیت ویرایش شد", "success");
      }
    } catch (err) {
      console.log(err);
      // setProducts(allProduct);
      const x = err.response.status;
      toast.error("خطایی رخ داده است مجدد تلاش کنید");
    }
  };
  return (
    <div>
      <div className="row align-items-center text-end">
        <div className="col-8">
          <label>متن توضیح : </label>
          <input className="admin-setting-input" id="title" />
        </div>
        <div className="col-4">
          <button
            className="btn ms-3 mt-3"
            style={{
              width: "100px",
              backgroundColor: "#EF971C",
              borderRadius: "20px",
            }}
            onClick={() => {
              addNew();
            }}
          >
            افزودن
          </button>
        </div>
      </div>
      <div className="table-responsive p-3 mt-4 admin-setting-tabel-box">
        <table
          className="table table-bordered text-center mb-0"
          style={{ borderRadius: "20px", borderColor: "#fff" }}
        >
          <thead>
            <tr style={{ color: "#000" }}>
              <th scope="col">ردیف</th>
              <th scope="col">عنوان</th>
              <th scope="col"></th>
            </tr>
          </thead>
          <tbody>
            {list.map((i, index) => (
              <tr style={{ color: "#000" }} key={index}>
                <td>{index + 1}</td>
                <td>
                  {" "}
                  <input
                    defaultValue={i.name}
                    id={`newName${i.id}`}
                    style={{
                      borderRadius: "20px",
                      width: "100%",
                    }}
                  />
                </td>
                <td>
                  <button
                    className="btn ms-3"
                    style={{
                      width: "80px",
                      backgroundColor: "#EF971C",
                      borderRadius: "20px",
                    }}
                    onClick={() => {
                      confirmDelete(i.id);
                    }}
                  >
                    حذف
                  </button>
                  <button
                    className="btn ms-3"
                    style={{
                      width: "80px",
                      backgroundColor: "#EF971C",
                      borderRadius: "20px",
                    }}
                    onClick={() => {
                      confirmEdit(i.id);
                    }}
                  >
                    ویرایش
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Description;
